import { ITranslations } from 'types/common';
import { ProfileTransFields } from './types';
import en from 'translations/en/profile.json';
import pl from 'translations/pl/profile.json';
import sl from 'translations/sl/profile.json';

export const profileTranslations: ITranslations<ProfileTransFields> = {
  name: 'profile',
  en,
  pl,
  sl,
};
